import { IPriority } from "../../types/Priority/IPriority";
import { IPrioritySet } from "../../types/Priority/IPrioritySet";
import { IStatus } from "../../types/Status/IStatus";
import { OpenTicketProps } from "../../types/Ticket/OpenTicketProps";
import { ISearchTicketResult, ITicket, ITicketListItem } from "../../types/Ticket/Ticket";
import { baseApi } from "./baseApi";
import { IAction } from "../../types/Ticket/IAction";

const ticketApi = baseApi.injectEndpoints({
    endpoints: (build) => ({

        getTicketList: build.query<ITicketListItem[], OpenTicketProps>({
            query: (props) => `/TicketList/?myTicketsOnly=${props.myTicketsOnly ? 'true' : 'false'}` + (props.companyIds ? `&companyIds=${props.companyIds?.join(",")}` : "") +
                (props.assignedToIds ? `&assignedContactIds=${props.assignedToIds?.join(",")}` : "") +
                (props.statusIds ? `&statusIds=${props.statusIds?.join(",")}` : "") +
                (props.priorityIds ? `&priority_Id=${props.priorityIds?.join(",")}` : "") +
                (props.projectIds ? `&projectIds=${props.projectIds?.join(",")}` : "") +
                (props.assignedTeamIds ? `&assignedTeamIds=${props.assignedTeamIds?.join(",")}` : ""),
            providesTags: ["TicketsList"],
        }),
        getPrioritySets: build.query<IPrioritySet[], void>({
            query: () => `/Ticket/PrioritySet/`,
            providesTags: ["PrioritySets"],
        }),
        getPriorityList: build.query<IPriority[], number>({
            query: (prioritySetId) => "Ticket/Priority/?prioritySetId=" + prioritySetId,
            providesTags: ["PriorityList"],
        }),
        getStatuses: build.query<IStatus[], number | void>({
            query: (statusTypeId) => "Ticket/Status?statusTypeId=" + (statusTypeId ?? -1),
            providesTags: ["Statuses"],
        }),
        searchTickets: build.mutation<ISearchTicketResult[], string>({
            query: (query) => ({
                url: "ticket/search",
                method: "POST",
                body: { Search_Phrase: query },
            }),
        }),
        logTicket: build.mutation<ITicket, ITicket>({
            query: (ticket) => ({
                url: "ticket",
                method: "POST",
                body: ticket,
            }),
            invalidatesTags: ["TicketsList"],
        }),
        addAction: build.mutation<unknown, { ticketId: number, action: IAction }>({
            query: ({ ticketId, action }) => ({
                url: `ticket/${ticketId}/action`,
                method: "POST",
                body: action,
            }),
            invalidatesTags: ["TicketsList"],
        }),
    }),
})


export { ticketApi };